import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateHtmlComponent } from './template-html.component';
import { ComponentsModule } from '../../../components/components.module';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TagModule } from 'primeng/tag';
import { TemplateEditComponent } from './template-edit/template-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { LivePreviewComponent } from './template-edit/live-preview/live-preview.component';
import { TestDataComponent } from './template-edit/test-data/test-data.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { DialogModule } from 'primeng/dialog';
import { PipesModule } from '../../../pipes/pipes.module';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { MessageModule } from 'primeng/message';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [TemplateHtmlComponent, TemplateEditComponent, LivePreviewComponent, TestDataComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    RouterModule,
    ButtonModule,
    TableModule,
    ToastModule,
    ConfirmDialogModule,
    TagModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    SelectButtonModule,
    MonacoEditorModule,
    DialogModule,
    PipesModule,
    MenuModule,
    TooltipModule,
    MessageModule,
    TranslateModule
  ],
  exports: [TemplateHtmlComponent, TemplateEditComponent]
})
export class TemplateHtmlModule { }
